import { ClassRating } from "constants/rate-classes";
import { IRateClassModalData } from "hooks/use-rate-class/use-rate-class.types";
import { IPrimaryUser } from "services/api/api.types";
import { IRestructuredPendingFeedbacksAPIResponse } from "services/api/class-feedback/classFeedbackService.types";

export interface IRateClassInitialRatingFormValues {
  rating: ClassRating;
  entity_id: string;
}
export interface IRateClassDetailedFormValues {
  tags: string[];
  comment: string;
}

export enum RatingFormStep {
  INITIAL_RATING,
  DETAILED_FEEDBACK,
  SUBMITTED
}
export interface IUseRateClassModalProps {
  initialRating: ClassRating | null;
  primaryUser: IPrimaryUser;
  metaData: IRestructuredPendingFeedbacksAPIResponse["metaData"];
  data: IRateClassModalData;
}

export interface IUseRateClassModalReturnValues {
  step: RatingFormStep;
  selectedRating: ClassRating | null;
  handleRatingFormSubmit: (data: IRateClassInitialRatingFormValues) => void;
  handleDetailedFormSubmit: (data: IRateClassDetailedFormValues) => void;
  handleDetailedFormSkip: () => void;
  handleRatingFormSkip: (entity_id: string) => void;
}
